<template>
  <MainComp />
</template>

<script setup>
import MainComp from './components/MainComp.vue'
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
</style>
